import React, { memo } from 'react';
import EntityDetail from 'containers/components/EntityDetail';
import { SALESORDERS } from 'constants/Entities';

const SalesOrdersDetail = memo(() => <EntityDetail entity={SALESORDERS} />);

export default SalesOrdersDetail;
